import "./ContactSales.css";
import botLogo from "../../Assets/logo-update.png";
import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import pricingLogo from "../../Assets/pricing.png";
import demoRequestLogo from "../../Assets/demo-request.png";
import questionsLogo from "../../Assets/question.png";
import threePersonImage from "../../Assets/threepersonImage.png";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function ContactSales() {
  const navigate = useNavigate();

  const formRef = useRef(null);
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    companyName: "",
    industry: "",
    message: "",
  });

  const handleChange = (e) => { setFormData({ ...formData, [e.target.name]: e.target.value }); };

  const handleSubmitformData = async () => {
    if (isSubmitting) return;
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.phoneNumber.trim() ||
      !formData.companyName.trim() ||
      !formData.industry.trim() ||
      !formData.message.trim()
    ) {
      toast.error("Please fill in all fields.");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      setIsSubmitting(true);

      const res = await fetch(`${API_BASE_URL}/api/auth/contact-sales`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Something went wrong");
      }

      toast.success("Your message has been sent successfully!");
      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        companyName: "",
        industry: "",
        message: "",
      });

    } catch (err) {
      console.error(err);
      toast.error(err.message || "Failed to submit form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="sales-wrapper">

      <div className="sales-navbar">
        <img src={botLogo} alt="Logo" className="sales-logo" />
        <button
          className="support-btn"
          onClick={() =>
            window.location.href =
            "mailto:support@xenachat.com?subject=Support%20Request"
          }
        >
          Contact Support
        </button>
      </div>

      <div className="sales-header">
        <h1>CONNECT WITH OUR SALES TEAM</h1>
      </div>

      <div className="sales-cards">

        <div className="sales-card">
          <div className="card-icon">
            <img src={demoRequestLogo} alt="Demo" className="card-icon-img" />
          </div>
          <h3>Demo Request</h3>
          <p>See our platform in action</p>
          <button className="card-btn" onClick={() => navigate("/bookdemo")}>
            Book a Demo
          </button>
        </div>

        <div className="sales-card">
          <div className="card-icon">
            <img src={pricingLogo} alt="Pricing" className="card-icon-img" />
          </div>
          <h3>Pricing Inquiry</h3>
          <p>Tailored solutions for you</p>
          <button className="card-btn" onClick={() => navigate("/pricing")}>
            View Plans
          </button>
        </div>

        <div className="sales-card">
          <div className="card-icon">
            <img src={questionsLogo} alt="Questions" className="card-icon-img" />
          </div>
          <h3>General Questions</h3>
          <p>We're here to help</p>
          <button className="card-btn" onClick={scrollToForm}>
            Send a Message
          </button>
        </div>

      </div>

      <div className="sales-form-section" ref={formRef}>

        <div className="form-left">
          <div className="input-row">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Work Email"
              value={formData.email}
              onChange={handleChange}
            />
            <input
              type="text"
              name="phoneNumber"
              placeholder="Phone Number"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
          </div>

          <div className="input-row">
            <input
              type="text"
              name="companyName"
              placeholder="Company Name"
              value={formData.companyName}
              onChange={handleChange}
            />
            <input
              type="text"
              name="industry"
              placeholder="Industry"
              value={formData.industry}
              onChange={handleChange}
            />
          </div>

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>

          <button
            className="submit-btn"
            onClick={handleSubmitformData}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "SUBMIT"}
          </button>

        </div>

        <div className="form-right">
          <div className="team-image">
            <img src={threePersonImage} alt="Team" />
          </div>
          <p>
            Prefer to call? +44 XXXX XXXXXX<br />
            Available Mon–Fri, 9 AM – 5 PM GMT/BST
          </p>
        </div>
      </div>

    </div>
  );
}